import Grid from '@mui/material/Grid';
import config from '../../app/config';
import makeStyles from '@mui/styles/makeStyles';
import {useDispatch, useSelector} from 'react-redux';
import {docTypes} from '../../store/reducers/dicts';
import {Checkbox, FormControl, FormControlLabel, IconButton, MenuItem, Select} from '@mui/material';
import {useTranslation} from 'react-i18next';
import AgyleButton from '../ui/buttons/agyleButton';
import React, {useEffect, useState} from 'react';
import {patient as patientPreferences, savePref} from '../../store/reducers/preferences';
import _ from "lodash";
import AgyleAccordion from '../ui/accordion/agyleAccordion';
import TextField from '@mui/material/TextField';
import {CustomAutocomplete} from '../../controls/uploadIMAGE';
import DeleteIcon from "@mui/icons-material/Delete";
import AgyleDialog from '../modal/agyleDialog';
import useOpenState from '../../hooks/useOpenState';
import Chip from '@mui/material/Chip';
import { v4 as uuidv4 } from 'uuid';
const useStyles = makeStyles((theme) => ({
    // modalBody: {
    //   //  background: "grey",
    //   //  color: "black",
    //     width: "60%",
    //     left: "20%",
    //     position: "absolute",
    //     top: "30px",
    //     padding: "20px",
    //     height: "90%",
    //     overflow: "auto",
    //     fontSize: "13px",
    //     borderRadius: "6px"
    // },
    modalBody: {
        width: "calc(100vw - 180px)",
        background: "#3D3E40",
        height: "98vh",
        borderLeft: "1px solid black",
        paddingLeft: 40,
      //  overflow: "auto"
        //  paddingTop: 35
    },
    title: {
        color: "#FFF",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 500,
        marginBottom: 25,
        marginTop: 25,
    },
    footer: {
        display: "inline-flex",
        width: "95%",
        justifyContent: "space-between",
        paddingTop: "25px"
    },
    displayImageContainer: {
        marginTop: 30,
        height: "50%",
        overflow: "auto"
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#ebebeb"
    }
}));

function SmartView(props) {
    const classes = useStyles();
    const docTypesDict = useSelector(docTypes);
    const { t, i18n } = useTranslation();

    const viewDisplay = [

        {
            name: "OS->OD",
            value: 1
        },
        {
            name: "OS->OD->OU",
            value: 2
        },
        {
            name: "OD->OS",
            value: 3
        },
        {
            name: "OD->OS->OU",
            value: 4
        },
        {
            name: "OU",
            value: 5
        },
        {
            name: "Open related",
            value: 6
        },
        // {
        //     name: "OS (open related)",
        //     value: 7
        // },
    ];

    const smartViewItemInit = {
        id: uuidv4() + '',
        name: "",
        mainTest: "",
        steps: []
    };

    const patientPreferencesObject = useSelector(patientPreferences);
    const [smartViewSet, setSmartViewSet] = React.useState([]);
    const [smartViewDefault, setSmartViewDefault] = React.useState({});
    const dispatch = useDispatch();

    const [displayImagePref, setDisplayImagePreferences] = React.useState({});
    const [selectedStepToManage, setSelectedStepToManage] = useState(null);
    const [isDisplayDialogOpen, openDisplayDialog, closeDisplayDialog] = useOpenState(false, true);

    useEffect(()=>{
        let smartViewTmp = _.cloneDeep(patientPreferencesObject.smartView);
        smartViewTmp.forEach((sm) => {
            if(!sm.hasOwnProperty("id")) {
                sm.id = uuidv4()+"";
            }
        })
        setSmartViewSet(smartViewTmp);
        setSmartViewDefault(_.cloneDeep(patientPreferencesObject.smartViewDefault));

        setDisplayImagePreferences((prefOld)=>{
            let pref = _.cloneDeep(patientPreferencesObject.studiesTypeViews);
            let newPref = {};

            docTypesDict.forEach((item) => {
                if(config.studiesType)
                    newPref[item.name] = config.studiesType[item.name]
                if(pref.hasOwnProperty(item.name))
                    newPref[item.name] = pref[item.name]
            });

           // setLoaded(true);

            return newPref;
        });
    },[patientPreferencesObject])


    const handleSetOrder = (index, viewIndex, value) => {
        let data = _.cloneDeep(smartViewSet);
        data[viewIndex].steps[index].view = value;
        setSmartViewSet(data);
    };

    const handleDeleteStep = (index, viewIndex) => {
        let data = _.cloneDeep(smartViewSet);
        data[viewIndex].steps.splice(index,1);
        setSmartViewSet(data);
    };

    const handleDeleteSmartView = (viewIndex) => {
        let data = _.cloneDeep(smartViewSet);
        data.splice(viewIndex,1);
        setSmartViewSet(data);
    };

    const handleSetHistory = (index, viewIndex, value) => {
        let data = _.cloneDeep(smartViewSet);
        data[viewIndex].steps[index].type = (value? "history": "current");
        setSmartViewSet(data);
    };

    const handleSetTest = (index, viewIndex, value) => {
        let data = _.cloneDeep(smartViewSet);
        data[viewIndex].steps[index].test = value;

        if(index !== 0) {
            data[viewIndex].steps[index].view = null;

            if(config.studiesType && config.studiesType[value])
                data[viewIndex].steps[index].view = config.studiesType[value]

            if(patientPreferencesObject.studiesTypeViews[value])
                data[viewIndex].steps[index].view = patientPreferencesObject.studiesTypeViews[value]
        }

        if(index === 0) data[viewIndex].mainTest = value;

        setSmartViewSet(data);
    };

    const handleSetName = (viewIndex, value) => {
        let data = _.cloneDeep(smartViewSet);
        data[viewIndex].name = value;
        setSmartViewSet(data);
    };

    const handleSavePreferences = () => {
        let data = _.cloneDeep(patientPreferencesObject);

        data.smartView = smartViewSet;
        data.studiesTypeViews = displayImagePref;
        data.smartViewDefault = smartViewDefault;

        dispatch(savePref(data));
    }

    const handleAddSmartItem = () => {
        let data = _.cloneDeep(smartViewSet);
        data.push(smartViewItemInit)
        setSmartViewSet(data);
    }

    const handleAddStep = (viewIndex) => {
        let data = _.cloneDeep(smartViewSet);
        let initValue = (data[viewIndex].steps.length === 0? [] : "");

        data[viewIndex].steps.push({
            test: initValue,
            type: "",
            view: null
        })
        setSmartViewSet(data);
    }

    const getValue = (value, index) => {
        if(index !== 0) return value;
        if(Array.isArray(value)) return value
        return [value]
    }

    const handleSetTestForMultipleTypes = (index, viewIndex, newValue) => {
        if(Array.isArray(newValue)) {
            let mapValues = [];
            newValue.forEach((value) => {
                if(_.isObject(value)) {
                    mapValues.push(value.name)
                } else {
                    mapValues.push(value)
                }
            })
            handleSetTest(index, viewIndex, mapValues);
        } else {
            handleSetTest(index, viewIndex, newValue.name);
        }
    }

    const handleSetNewPreferences = (type, value) => {
        setDisplayImagePreferences((pref) => {
            pref[type.toString()] = value;
            return {...pref}
        });
    };

    const filterDictType = (view) => {
        return docTypesDict.filter((option) => {
            let countItems = 0;
            view.steps.forEach((step) => {
                if(step.test === option.name) {
                    countItems++;
                }
            })
            return countItems < 2
        })
    }


    const handleSetNewDefaultSmartView = (option, id) => {
        let testName = option.name? option.name: option;
        setSmartViewDefault((smartViewDef) => {
            smartViewDef[testName] = id;
            return {...smartViewDef}
        });
    };

    const handleResetNewDefaultSmartView = (option, id) => {
        let testName = option.name? option.name: option;
        setSmartViewDefault((smartViewDef) => {
            if(smartViewDef.hasOwnProperty(testName) && id === smartViewDef[testName])
                smartViewDef[testName] = null;
            return {...smartViewDef}
        });
    };

    const isDefaultSmartView = (option, id) => {
        let testName = option.name? option.name: option;
        return smartViewDefault.hasOwnProperty(testName) && smartViewDefault[testName] === id;
    }

    const renderSmartViewItem = (view, viewIndex) => {
        return  <div style={{borderBottom: "1px solid #626466", padding: 20}} key={viewIndex+"SV"}> <Grid container spacing={1}>
            <Grid item xs = {11}>
                <TextField
                    value={view.name}
                    onChange={(e) => handleSetName(viewIndex, e.target.value)}
                    label={"Name"}
                    fullWidth
                    variant="outlined"
                />

            </Grid>
            <Grid item xs = {1}>
                <div style={{textAlign: "center"}}>
                    <IconButton
                        size="small"
                        disableRipple={true}
                        onClick={()=>{ handleDeleteSmartView(viewIndex)}}>
                        <DeleteIcon/>
                    </IconButton>
                </div>
            </Grid>
            {view.steps.map((step, index)=>{
                return <Grid item xs={12}>
                    <Grid container alignItems={"center"} >
                        <Grid item xs={4}>
                            {docTypesDict &&
                                <CustomAutocomplete
                                    disableListWrap
                                    options={filterDictType(view)}
                                    getOptionLabel={(option) => option && option.name ? option.name : option}
                                    style={{ width: "100%" }}
                                    value={getValue(step.test, index)}
                                    multiple={index === 0}
                                    onChange={(event, newValue) => {
                                        handleSetTestForMultipleTypes(index, viewIndex, newValue)
                                    }}
                                    renderTags={(tagValue, getTagProps) =>
                                        tagValue.map((option, index2) => {
                                            return (
                                                <Chip
                                                    key={index+"_"+index2}
                                                    label={option && option.name ? option.name : option}
                                                    color={isDefaultSmartView(option, view.id)? "primary" : "default"}
                                                    clickable
                                                    style={{margin: 3}}
                                                    onClick={()=> {
                                                        handleSetNewDefaultSmartView(option, view.id)
                                                    }}
                                                    onDoubleClick={()=>{
                                                        handleResetNewDefaultSmartView(option, view.id)
                                                    }}
                                                    onDelete={()=>{
                                                        handleResetNewDefaultSmartView(option, view.id)
                                                        let newValue = [...getValue(step.test, index)];
                                                        newValue.splice(index2, 1);
                                                        handleSetTestForMultipleTypes(index, viewIndex, newValue)
                                                    }}
                                                />
                                            );
                                        })
                                    }
                                    getOptionSelected={(option, value) => option.name === value}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            size="small" label={t("Document type")}
                                            placeholder={t("select doctype")}
                                            variant="outlined" />}
                                />
                            }
                        </Grid>
                        <Grid item xs={3}>
                            <div style={{textAlign: "center"}}>
                                { index !== 0 &&
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={step.type === "history"}
                                                onChange={(event)=>{
                                                    handleSetHistory(index, viewIndex, event.target.checked);
                                                }}
                                            />}
                                        label={"History"}
                                    />
                                }
                            </div>


                        </Grid>
                        <Grid item xs={4}>
                            { index !== 0 && <FormControl sx={{width: "100%"}}>
                                <Select
                                    value={displayImagePref[getValue(step.test, index)] || null}
                                    displayEmpty
                                    //disabled={step.test === "OCT"}
                                    onChange={(event) => {
                                       // handleSetOrder(index,viewIndex, event.target.value);
                                        handleSetNewPreferences(getValue(step.test, index), event.target.value);
                                    }}
                                >
                                    <MenuItem value={null}>
                                        <em>Normal</em>
                                    </MenuItem>

                                    {viewDisplay && viewDisplay.map(r => {
                                        return (<MenuItem value={r.value} key={r.name}>{r.name}</MenuItem>)
                                    })
                                    }
                                </Select>
                            </FormControl>
                            }
                            { index === 0 &&
                                <FormControl sx={{width: "100%"}}>
                                    <AgyleButton
                                        onClick={()=>{
                                            setSelectedStepToManage(viewIndex)
                                            openDisplayDialog()

                                        }}
                                        colour="primary"
                                    >
                                        {t("Set Image display")}
                                    </AgyleButton>
                                </FormControl>
                            }
                        </Grid>
                        <Grid item xs={1}>
                            <div style={{textAlign: "center"}}>
                                <IconButton
                                    size="small"
                                    disableRipple={true}
                                    onClick={()=>{ handleDeleteStep(index, viewIndex)}}>
                                    <DeleteIcon/>
                                </IconButton>
                            </div>
                        </Grid>
                    </Grid>


                </Grid>
            })}
            <Grid item xs={12}>
                <AgyleButton
                    size="small"
                    onClick={()=>handleAddStep(viewIndex)}
                >
                    Add Step
                </AgyleButton>
            </Grid>
        </Grid>
        </div>
    }

    const buttons = () => {
        let b = [];
        b.push( <AgyleButton
            size="small"
            onClick={handleAddSmartItem}
        >
            Add Smart View
        </AgyleButton>)

        b.push( <AgyleButton
            size="small"
            color="primary"
            onClick={handleSavePreferences}
        >
            Save
        </AgyleButton>)
        return b;
    }

    return (
        <div className={classes.modalBody}>
            <div className={classes.title}>
                Smart View
            </div>
            <div style={{height: "calc(100vh - 150px)"}} className={"scroll-normal-white"}>
                {smartViewSet && smartViewSet.map((view, viewIndex) => {
                    return renderSmartViewItem(view, viewIndex)
                })}
            </div>
            <div className={classes.footer}>
                {buttons()}
            </div>
            <AgyleDialog
                title={"Set Image Display"}
                open={isDisplayDialogOpen}
                onClose={closeDisplayDialog}
                contentStyle={classes.dialogContentStyle}
                fullWidth
                disableSave
                alignActionsCloseButtonToRight
            >
                <div>
                    {selectedStepToManage != null &&
                        smartViewSet[selectedStepToManage].steps[0].test.map((name) => {
                            return <Grid container key={name} alignItems={"center"} spacing={2} >
                                <Grid item xs={6}> {name} </Grid>
                                <Grid item xs={6}>
                                    <FormControl sx={{width: "100%"}}>
                                        <Select
                                            value={displayImagePref[name.toString()] || null}
                                            displayEmpty
                                           // disabled={name === "OCT"}
                                            onChange={(event) => {
                                                handleSetNewPreferences(name, event.target.value);
                                            }}
                                        >
                                            <MenuItem value={null}>
                                                <em>Normal</em>
                                            </MenuItem>
                                            {viewDisplay && viewDisplay.map(r => {
                                                return (<MenuItem value={r.value} key={r.name}>{r.name}</MenuItem>)
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        })
                    }
                </div>
            </AgyleDialog>
        </div>
   );
};

export default SmartView;